import { createApp } from 'vue'
import { createPinia } from 'pinia'

// Import router
import { createAppRouter } from './router/index.js'

// Import root component
import App from './App.vue'

// Import styles
import './assets/styles/main.css'

// Create app instance
const app = createApp(App)

// Create and setup pinia store
const pinia = createPinia()
app.use(pinia)

// Create and setup router
const router = createAppRouter()
app.use(router)

// Mount app
app.mount('#app')
